import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { numberOrStringType } from '@ecp/common/src/style/propTypes';
import useSwiperArrow from '@ecp/common/src/components/swiper/useSwiperArrow';
import { DisabledStyle } from '@ecp/common/src/components/swiper/component/SwiperArrow';
import { ReactComponent as IconLeftArrow } from '@ecp/common/src/assets/icon/icon__bo__arrow--left.svg';
import { ReactComponent as IconRightArrow } from '@ecp/common/src/assets/icon/icon__bo__arrow--right.svg';

const getArrowProps = ({ padding, type = '8', position = 'outer', direction = 'left', top }) => {
  switch (type) {
    case '32':
      return {
        [direction]: `${position === 'outer' ? '-' : ''}${padding ? padding : '0px'}`,
        width: '32px',
        height: '32px',
        top: top ?? 'calc(50% - 30px)',
        padding: '11px 13px',
        backgroundColor: 'rgba(255, 255, 255, 0.6)',
        lineHeight: 0,
      };
    case '8':
    default:
      return {
        [direction]: `${position === 'outer' ? '-' : ''}${padding ? padding : '20px'}`,
        top: top ?? 'calc(50% - 23px)',
        width: '20px',
        height: '36px',
        border: '1px solid #CCCCCC',
        padding: '7px 6px',
        backgroundSize: '8px 16px',
        backgroundColor: '#ffffff',
      };
  }
};

const StyledArrow = styled.span`
  position: absolute;
  z-index: 2;
  background: none;
  border: none;
  display: inline-block;
  content: '';
  cursor: pointer;
  ${(props) => getArrowProps(props)};
  ${({ isEdge }) => (isEdge ? DisabledStyle : '')};
`;

export const ArrowPrev = ({ onClick, ...props }) => {
  const { handleClick } = useSwiperArrow({ onClick });

  return (
    <StyledArrow direction="left" onClick={handleClick} {...props}>
      <IconLeftArrow />
    </StyledArrow>
  );
};

ArrowPrev.displayName = 'ArrowPrev';

ArrowPrev.propTypes = {
  padding: numberOrStringType,
  type: PropTypes.oneOf(['8', '32']),
  position: PropTypes.oneOf(['outer', 'inner']),
  top: PropTypes.string,
  onClick: PropTypes.func,
  isEdge: PropTypes.bool,
};

export const ArrowNext = ({ onClick, ...props }) => {
  const { handleClick } = useSwiperArrow({ onClick });

  return (
    <StyledArrow direction="right" onClick={handleClick} {...props}>
      <IconRightArrow />
    </StyledArrow>
  );
};
ArrowNext.displayName = 'ArrowNext';

ArrowNext.propTypes = {
  padding: numberOrStringType,
  type: PropTypes.oneOf(['8', '32']),
  position: PropTypes.oneOf(['outer', 'inner']),
  top: PropTypes.string,
  onClick: PropTypes.func,
  isEdge: PropTypes.bool,
};
